import React from 'react';
import PropTypes from 'prop-types';

import Dot from '../elements/Dot';
import '../styles/StartMenu.css';

import {ReactComponent as FanIcon} from '../icons/fan-icon.svg';
import {ReactComponent as SDIoffIcon} from '../icons/sdi-off-icon.svg';
import {ReactComponent as AutoFocus} from '../icons/auto-focus-icon.svg';
import {ReactComponent as CLog} from '../icons/c.log3-icon.svg';
import {ReactComponent as IsoIcon} from '../icons/iso-icon.svg';
import {ReactComponent as WhiteBalance} from '../icons/white-balance-icon.svg';

const icons = {
    autoFocus: <AutoFocus className="Icon-topbar" />,
    cLog: <CLog className="Icon-topbar" />,
    fanIcon: <FanIcon className="Icon-topbar" />,
    sdiOffIcon: <SDIoffIcon className="Icon-topbar" />,
    isoIcon: <IsoIcon className="Icon-topbar" />, 
    whiteBalance: <WhiteBalance className="Icon-topbar" />
}

const StartMenu = ({ resolution, colorSampling }) => (
    <div className="Start-screen-wrapper">
      <ul className="Side-bar-1">
        <li>18mm</li>
        <li>{icons.autoFocus}</li>
        <li>{icons.cLog}</li>
      </ul>
      <ul className="Side-bar-2">
        <li>{colorSampling}</li>
        <li>{resolution}</li>
        <li className="Side-bar-2-sdi">{icons.sdiOffIcon}</li>
        <li className="Side-bar-2-dots">
          <div className="Dots-wrapper">
            <div className="Dots-column-1">
                { Array.from({length:5}, (value, index) => <Dot className="Dot" key={index} />) }
                <Dot className="Dot Dot-with-right-line" />
              <span className="Digit">1</span>
            </div>
            <div className="Dots-column-2">
                { Array.from({length:5}, (value, index) => <Dot className="Dot" key={index} />) }
                <Dot className="Dot Dot-with-left-line" />
                <span className="Digit">2</span>
            </div>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </li>
      </ul>
      <ul className="Footer-bar-1">
        <li>A001C001</li>
        <li className="Footer-bar-1-fan">{icons.fanIcon}</li>
        <li className="Footer-bar-1-scale">
        <div className="Scale-wrapper">
          <span className="Scale-minus">-</span>
          <span className="Scale-blink"></span>
          <span className="Scale-triangle"></span>
          <span className="Scale-plus">+</span>
          <div className="Scale">
              <div className="Scale-row-1">
                { Array.from({length:9}, (value, index) => <Dot className="Dot-small" key={index} />) }
              </div>
              <div className="Scale-row-2">
                { Array.from({length:9}, (value, index) => <Dot className="Dot-small" key={index} />) }
              </div>
            </div>
        </div>
        </li>
      </ul>
      <ul className="Footer-bar-2">
        <li className="Footer-bar-2-item">{icons.whiteBalance} A</li>
       
        <li className="Footer-bar-2-item">5600K</li>
        <li className="Footer-bar-2-item">&plusmn; OCC</li>
        <li className="Footer-bar-2-item item-wide item-wide-right">T 4.5</li>
        <li className="Footer-bar-2-item item-wide">{icons.isoIcon} 800</li>
        <li className="Footer-bar-2-item item-wide">1/60</li>
      </ul>
    </div>
)

StartMenu.propTypes = {
  resolution: PropTypes.string.isRequired,
  colorSampling: PropTypes.string.isRequired,
}

export default StartMenu;